import React, { useContext } from 'react';
import styles from './style.cssmodule.css';
import AccountsTable from '../AccountsTable/AccountsTable';
import AccountsCards from '../AccountsCards/AccountsCards';
import NoResults from '../NoResults/NoResults';
import { AccountsContext } from '../../contexts/AccountsContext';
import TableFooter from '../TableFooter/TableFooter';
import ModalArchiveAccount from '../ModalArchiveAccount/ModalArchiveAccount';
import ModalDeleteAccount from '../ModalDeleteAccount/ModalDeleteAccount';

function Accounts() {
  const { accounts } = useContext(AccountsContext);
  if (!accounts) return null;
  const hasAccounts = accounts.length > 0;

  return (
    <div>
      <div className={styles.listWrapper}>
        <div className={styles.mobile}>
          <AccountsCards />
        </div>
        <div className={styles.desktop}>
          <AccountsTable />
        </div>
        {!hasAccounts && <NoResults />}
      </div>
      <TableFooter />
      <ModalArchiveAccount />
      <ModalDeleteAccount />
    </div>
  );
}

export default Accounts;



// WEBPACK FOOTER //
// ./routes/cpm/routes/accounts/components/Accounts/Accounts.jsx